<template functional>
  <div :class="['Headline', data.class, data.staticClass]">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.Headline {
  color: $main;
  font-weight: $semibold;
  margin-bottom: 1rem;
  @include md {
    margin-bottom: 2rem;
  }

  &::before {
    border-top: 2px solid;
    content: ' ';
    display: inline-block;
    font-size: 2rem;
    height: 0.5rem;
    margin-right: 0.5rem;
    width: 1rem;
  }

  &.white {
    color: $white;
  }
}
</style>
